import { Tooltip } from 'antd';
import { HTMLAttributes, useEffect, useState } from 'react';
import { MdContentCopy } from 'react-icons/md';
import { AiFillCheckCircle } from 'react-icons/ai';
import { useTheme } from 'styled-components';

export const CopyIcon: React.FC<HTMLAttributes<HTMLDivElement> & { text: string }> = ({ text }) => {
	const [copied, setCopied] = useState<boolean>(false);
	const theme = useTheme();
	useEffect(() => {
		if (copied) {
			setTimeout(() => setCopied(false), 2000);
		}
	}, [copied]);
	return (
		<Tooltip title={copied ? 'Copied' : 'Copy'}>
			{copied ? (
				<AiFillCheckCircle color={theme.TA_GREEN} size={24} />
			) : (
				<MdContentCopy
					style={{ cursor: 'pointer' }}
					onClick={() => {
						navigator.clipboard.writeText(text).then(() => setCopied(true));
					}}
					color={theme.TA_GREEN}
					size={24}
				/>
			)}
		</Tooltip>
	);
};
